export const REAL_BRL = {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
}



// WEBPACK FOOTER //
// ./src/utils/helpers/money.js